import { ExclamationCircleIcon } from "@heroicons/react/24/solid";
import cx from "classnames";
import React from "react";
import { UseFormRegister } from "react-hook-form";

type InputwithLabelType = {
  name: string;
  label?: string;
  touchedFields: any;
  errors: any;
  register: UseFormRegister<any>;
  tx: any;
  placeholder: string;
  Icon?: React.ComponentType<React.ComponentProps<"svg">>;
  invalidText?: string;
  required: boolean;
  autoFocus?: boolean;
  InputElement?: JSX.Element;
  type: string;
  className?: string;
  disabled: boolean;
  pattern?: RegExp;
};

export default function InputWithLabel({
  name,
  label,
  touchedFields,
  errors,
  register,
  tx,
  placeholder,
  Icon,
  required,
  autoFocus,
  InputElement,
  invalidText,
  type,
  className,
  disabled,
  pattern = undefined,
}: InputwithLabelType) {
  return (
    <div className={cx("sm:col-span-2", className)}>
      {label && (
        <label
          htmlFor={name}
          className={cx("mb-1 block text-sm font-medium text-gray-700", {
            "text-red-500 ": errors[name],
            "text-green-500": !errors[name] && touchedFields[name],
          })}
        >
          {label}
        </label>
      )}
      <div className="relative">
        {Icon && (
          <div className="pointer-events-none absolute inset-y-0 left-0 flex items-center pl-3">
            <Icon
              className={cx("h-5 w-5 text-gray-500 dark:text-gray-400", {
                "text-red-500 dark:text-red-500": errors[name],
                "text-green-500 dark:text-green-500":
                  !errors[name] && touchedFields[name],
              })}
            />
          </div>
        )}
        {InputElement ? (
          InputElement
        ) : (
          <input
            id={name}
            type={type}
            autoComplete={["email", "tel"].includes(type) ? type : "off"}
            autoFocus={autoFocus}
            className={cx(
              "block w-full rounded-md border border-gray-300 px-4 py-3 pl-10 focus:border-primary-600 focus:ring-primary-600",
              {
                "border-red-300 text-red-900 placeholder-red-300 focus:border-red-500 focus:ring-red-500":
                  errors[name],
              },
              {
                "border-green-500 text-green-500 placeholder-green-300 focus:border-green-500 focus:ring-green-500":
                  !errors[name] && touchedFields[name],
              }
            )}
            placeholder={placeholder}
            required={required}
            disabled={disabled}
            {...register(name, {
              required,
              pattern: {
                value: pattern,
                message: invalidText,
              },
            })}
          />
        )}
        {errors[name]?.type === "required" && (
          <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-3">
            <ExclamationCircleIcon
              className="h-5 w-5 text-red-500"
              aria-hidden="true"
            />
          </div>
        )}
      </div>
      {errors[name]?.type === "required" && (
        <p className="mt-2 text-sm text-red-600">{tx!.required}</p>
      )}
      {errors[name]?.type === "validate" && (
        <p className="mt-2 text-sm text-red-600">{invalidText}</p>
      )}
      {errors[name]?.type === "pattern" && (
        <p className="mt-2 text-sm text-red-600">{invalidText}</p>
      )}
    </div>
  );
}
